export enum HorizontalFocus {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  START = 'start',
  END = 'end',
}
